import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PaginationComponent } from '@rma/public/generic/ui/pagination';
import { SkeletonBlockComponent } from '@rma/public/generic/ui/skeleton';
import { GroupProfileCardComponent } from '@rma/public/locations/private/orc-group-profile-card';
import { LOCATION_PROFILE_FACADE, LocationProfilePageComponent } from '@rma/public/locations/private/orc-profile-page';
import { LocationEmptyComponent } from '@rma/public/locations/private/ui-error-empty-state';
import { LocationGroupsFacade } from './location-groups.facade';

@Component({
  selector: 'rma-location-groups',
  templateUrl: './location-groups.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    LocationEmptyComponent,
    LocationProfilePageComponent,
    GroupProfileCardComponent,
    PaginationComponent,
    SkeletonBlockComponent,
  ],
  providers: [{ provide: LOCATION_PROFILE_FACADE, useClass: LocationGroupsFacade }],
})
export class LocationGroupsComponent {}
